import React, { useEffect, useState } from "react";
import RichText from "components/RichText";
import style from "./index.module.scss";
import Scroll, { Element } from "react-scroll";
import { useReadAddApi } from "./hooks";
import Utils from 'utils/utils.js';

const QuestionDetail = ({ detail }) => {
  const [contentFlag, setContentFlag] = useState([]);

  const readContentAdd = useReadAddApi();

  const scroller = Scroll.scroller;


  useEffect(() => {
    console.log(detail)
    let index = detail.findIndex(item => item.articleId == getQueryVariable('id'));
    let arr = new Array(detail.length).fill(false);
    if(index > -1) {
      arr[index] = true;

      scroller.scrollTo(getQueryVariable('id'), {
        duration: 300,
        delay: 200,
        smooth: true,
        offset: 0, 
      })

      readContentAdd({
        articleId:getQueryVariable('id')
      })
    }
    setContentFlag(arr);

  },[detail]);

  function showMoreContent(item,index) {
  
    if(!contentFlag[index]){
      // 增加埋点记录
      readContentAdd({
        articleId:item.articleId
      })
    }

    setContentFlag(contentFlag.map((value, key) => key === index ? !value : false));
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return "";
  }

  return (
    <div className={`${style.articleDetail}`}>
      <div className={`${style.faqContentItem}`} id="scrollContainer">
        <div className={`${style.faqContentHeader}`}></div>
        {detail &&
          detail.map((item, index) => {
            return (
              <div key={ item.articleId } className={`${style.faqContentItem}`} onClick={() => showMoreContent(item,index)}>
                <div className={`${style.itemHeader}`}>
                  <div className={`${style.itemHeaderLeft}`}>
                    <Element name={item.articleId}>
                      <div className={`${style.header} ${contentFlag[index] ? style.headerActive : ''}` }>
                        {item.articleName}
                      </div>
                    </Element>
                    <div className={`${style.date}`}>
                      最后更新日期：{item.updateTime}
                    </div>
                  </div>
                  <div
                    className={`${style.showMore}`}
                  >
                    <div className={`${style.show}`}>
                      {contentFlag[index] ? "收起" : "展开"}
                    </div>
                    <div className={`${style.icon}`}>
                      { contentFlag }
                      {contentFlag[index] ? (
                        <img
                          src="https://s2-relay.360buyimg.com/relay/cache/cut/8b8f22934ce58900efa8569c56a26279"
                          alt=""
                        />
                      ) : (
                        <img
                          src="https://img12.360buyimg.com/imagetools/jfs/t1/136955/36/13151/383/5f904fa6E5a763cdc/ea07ac64495d1923.png"
                          alt=""
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className={`${style.item} ${contentFlag[index] ? '' : style.hide}`}>
                    <RichText
                      className={`${style.faqContentText}`}
                      html={`
                              <style>
                                body,p{
                                  padding:0;
                                  margin:0
                                }
                                a {
                                  word-break: break-all;
                                }
                                span{
                                  font-size:14px
                                }
                              </style>
                              ${item.bigContent || ""}
                            `}
                    />
                  </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default QuestionDetail;
